
<template>
  <div class="share-buttons">
    <span class="share-buttons__label mq-not-mobile">
      Поделиться:
    </span>
    <BasicButton
      v-if="providers.includes('vk')"
      title="Опубликовать ссылку во ВКонтакте"
      @click="openVkWindow"
    >
      <SvgIcon
        source="/images/social-v5.svg"
        icon="vk"
        :size="24"
      />
    </BasicButton>

    <BasicButton
      v-if="providers.includes('twitter')"
      title="Твиттнуть"
      :href="`http://twitter.com/intent/tweet?text=${text}+${absoluteUrl}+via+%40moikrug`"
      rel="nofollow"
      target="_blank"
    >
      <SvgIcon
        source="/images/social-v5.svg"
        icon="twitter"
        :size="24"
      />
    </BasicButton>

    <BasicButton
      v-if="providers.includes('facebook')"
      title="Опубликовать ссылку в Facebook"
      @click="openFbWindow"
    >
      <SvgIcon
        source="/images/social-v5.svg"
        icon="facebook"
        :size="24"
      />
    </BasicButton>
  </div>
</template>

<script>
import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'ShareButtons',

  components: {
    BasicButton,
    SvgIcon,
  },

  props: {
    url: String,
    text: String,
    providers: {
      type: Array,
      default: () => ['vk', 'facebook', 'twitter'],
    },
  },

  methods: {
    openVkWindow() {
      const vkUrl = `https://vk.com/share.php?url=${this.absoluteUrl}`;
      window.open(vkUrl, 'Опубликовать ссылку во Вконтакте', 'width=800,height=300');
    },

    openFbWindow() {
      const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.absoluteUrl}`;
      window.open(fbUrl, 'Опубликовать ссылку во Вконтакте', 'width=800,height=300');
    },
  },

  computed: {
    absoluteUrl() {
      const { host, protocol } = window.location;
      return `${protocol}//${host}${this.url}`
    },
  },
}
</script>